import SecureLS from 'secure-ls';

const ls = new SecureLS({ encodingType: "aes" });
const API_BASE_URL = 
  // 'https://rentacourt-backend-2kch.onrender.com/api';
  // 'http://localhost:7002/api'
  'https://rentacourt-backend-pg.onrender.com/api'; // Make sure to add 'http://' at the beginning

// Centralized token getter (matches AuthContext and request.js)
const getStoredToken = () => {
  try {
    // First try SecureLS
    const secureToken = ls.get('token');
    if (secureToken) return secureToken;
    
    const secureAuthToken = ls.get('authToken');
    if (secureAuthToken) return secureAuthToken;
  } catch (e) {
    console.warn('SecureLS access failed in apiConfig:', e.message);
  }
  
  // Fallback to localStorage
  return localStorage.getItem('authToken') || localStorage.getItem('token');
};

// Check if token is expired (same logic as other files)
function isTokenExpired(token) {
  if (!token) return true;
  
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedToken = JSON.parse(window.atob(base64));
    
    // Add 1 minute buffer
    const now = Date.now() / 1000;
    const expiry = decodedToken.exp;
    
    return expiry <= now + 60; // 1 minute buffer
  } catch (e) {
    console.error('Error checking token expiration:', e);
    return true;
  }
}

// Clear all auth data (matches other files)
const clearAuthData = () => {
  try {
    ls.remove('token');
    ls.remove('authToken');
    ls.remove('userData');
  } catch (e) {
    console.warn('SecureLS cleanup failed in apiConfig');
  }
  
  localStorage.removeItem('authToken');
  localStorage.removeItem('token');
  localStorage.removeItem('userData');
};

const apiConfig = {
  parseJwt: function(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(window.atob(base64));
    } catch (e) {
      return null;
    }
  },

  fetchWithAuth: async (endpoint, options = {}) => {
    const token = getStoredToken();
      // Check if token exists
    if (!token) {
      clearAuthData();
      window.location.href = '/admin/login';
      return null;
    }
    
    // Check if token is expired
    if (isTokenExpired(token)) {
      clearAuthData();
      window.location.href = '/admin/login';
      return null;
    }

    const defaultHeaders = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };

    const config = {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers
      },
      credentials: 'include'
    };

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

      if (!response.ok) {
        if (response.status === 401) {
          clearAuthData();
          window.location.href = '/admin/login';
          return null;
        }

        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || `HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API Fetch Error:', error);
      
      // Handle network errors that might indicate auth issues
      if (error.message.includes('401') || error.message.includes('Unauthorized')) {
        clearAuthData();
        window.location.href = '/admin/login';
        return null;
      }
      
      throw error;
    }
  }
};

export default apiConfig;